import { createRouter, createWebHistory } from 'vue-router'
import { getAgeStatus } from '../apis/ageProfile'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/home/Home.vue')
  },
  { path: '/age-profile', name: 'AgeProfile', component: () => import('../views/AgeProfile.vue') },
  {
    path: '/voice-clone',
    name: 'voiceClone',
    // 使用动态导入，保持与其他路由一致的风格
    component: () => import('../views/voice/VoiceClonePage.vue')
  },
  {
    path: '/voice-clone-migration',
    name: 'voiceCloneMigration',
    component: () => import('../views/voice/VoiceCloneMigrationPage.vue')
  },
  {
    path: '/music',
    name: 'music',
    component: () => import('../views/music/MusicLibraryPage.vue')
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: () => import('../views/schedule/SchedulePage.vue')
  },
  {
    path: '/agents/:agentId/device-theme',
    name: 'deviceTheme',
    component: () => import('../views/theme/DeviceThemePage.vue')
  },
  {
    path: '/wallpaper-library',
    name: 'wallpaperLibrary',
    component: () => import('../views/theme/WallpaperLibraryManagePage.vue')
  },
  { path: '/', redirect: '/home' },
  { path: '/:pathMatch(.*)*', redirect: '/home' }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// 路由守卫：未登录跳转到登录页，已登录访问登录页跳转主页
router.beforeEach(async (to, from, next) => {
  // 仅用于本地视觉验收，不进入生产构建逻辑。
  if (import.meta.env.DEV && to.query.preview === '1') {
    next();
    return;
  }
  // 动态获取token，避免循环依赖
  const token = localStorage.getItem('token');

  // 如果访问登录页且已有token，跳转到主页
  if (to.path === '/login' && token) {
    next('/home');
    return;
  }

  // 如果访问非登录页且没有token，跳转到登录页
  if (to.path !== '/login' && !token) {
    next('/login');
    return;
  }

  if (token && to.path !== '/login' && to.path !== '/age-profile') {
    try {
      const age = await getAgeStatus()
      if (!age.accessAllowed && (age.declared || age.runtimeEnabled)) {
        next('/age-profile')
        return
      }
    } catch {
      // 运行时由服务端再拦截；旧后端尚无年龄接口时保留原 PC 准入。
    }
  }

  // 如果有token，让请求拦截器处理token验证
  // 这样可以确保token验证的实时性
  next();
});

export default router
